import enUS from 'tdesign-mobile-vue/es/locale/en_US'
import zhCN from 'tdesign-mobile-vue/es/locale/zh_CN'
import type { GlobalConfigProvider } from 'tdesign-mobile-vue/es/config-provider/type'

import type { AppLocale } from '@/locales'

export function resolveTDesignLocale(locale: AppLocale): GlobalConfigProvider {
  return locale === 'en' ? enUS : zhCN
}
